import React from 'react';
import './LegalPages.css';

function TermsOfService({ onClose }) {
  return (
    <div className="legal-page-overlay" onClick={onClose}>
      <div className="legal-page-content" onClick={(e) => e.stopPropagation()}>
        <div className="legal-page-header">
          <h1>Terms of Service</h1>
          <button className="legal-page-close" onClick={onClose}>×</button>
        </div>
        
        <div className="legal-page-body">
          <p className="legal-last-updated">Last updated: January 1, 2025</p>
          
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using Swift Notes ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>Swift Notes is an AI-powered note-taking application that provides:</p>
            <ul>
              <li>Note creation, editing, and organization tools</li>
              <li>AI-enhanced note formatting and content improvement</li>
              <li>File upload and multimedia support</li>
              <li>Speech-to-text functionality</li>
              <li>Cloud synchronization and storage</li>
              <li>Folder organization and management</li>
            </ul>
          </section>

          <section>
            <h2>3. User Accounts and Registration</h2>
            <p>To access certain features, you must register for an account. You agree to:</p>
            <ul>
              <li>Provide accurate, current, and complete information</li>
              <li>Maintain and update your information to keep it accurate</li>
              <li>Maintain the security of your password and account</li>
              <li>Accept responsibility for all activities under your account</li>
              <li>Notify us immediately of any unauthorized use</li>
            </ul>
          </section>

          <section>
            <h2>4. User Responsibilities and Prohibited Uses</h2>
            <p>You agree not to use the Service to:</p>
            <ul>
              <li>Upload, post, or transmit any unlawful, harmful, or objectionable content</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe upon intellectual property rights of others</li>
              <li>Attempt to gain unauthorized access to the Service</li>
              <li>Interfere with or disrupt the Service or servers</li>
              <li>Use the Service for any commercial purpose without authorization</li>
              <li>Upload malicious code, viruses, or harmful software</li>
              <li>Harass, abuse, or harm another person</li>
            </ul>
          </section>

          <section>
            <h2>5. Subscription and Payment Terms</h2>
            <p>For Pro subscriptions:</p>
            <ul>
              <li>Subscription fees are billed monthly in advance</li>
              <li>All fees are non-refundable except as required by law</li>
              <li>We may change subscription prices with 30 days notice</li>
              <li>You may cancel your subscription at any time</li>
              <li>Upon cancellation, access to Pro features ends at the current billing period</li>
            </ul>
          </section>

          <section>
            <h2>6. Intellectual Property Rights</h2>
            <p>The Service and its original content, features, and functionality are owned by Swift Notes and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.</p>
            <p>You retain ownership of content you create, but grant us a license to use, store, and display your content as necessary to provide the Service.</p>
          </section>

          <section>
            <h2>7. Privacy and Data Protection</h2>
            <p>Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your information when you use our Service. By using our Service, you agree to the collection and use of information in accordance with our Privacy Policy.</p>
          </section>

          <section>
            <h2>8. Service Availability and Modifications</h2>
            <p>We strive to maintain high availability but do not guarantee uninterrupted access. We reserve the right to:</p>
            <ul>
              <li>Modify or discontinue the Service with or without notice</li>
              <li>Perform maintenance that may temporarily limit access</li>
              <li>Update these terms with reasonable notice</li>
            </ul>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, SWIFT NOTES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.</p>
          </section>

          <section>
            <h2>10. Disclaimers</h2>
            <p>THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</p>
          </section>

          <section>
            <h2>11. Indemnification</h2>
            <p>You agree to defend, indemnify, and hold harmless Swift Notes and its officers, directors, employees, and agents from and against any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of the Service or violation of these terms.</p>
          </section>

          <section>
            <h2>12. Termination</h2>
            <p>We may terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.</p>
          </section>

          <section>
            <h2>13. Governing Law and Dispute Resolution</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions. Any disputes arising from these terms or the Service shall be resolved through binding arbitration.</p>
          </section>

          <section>
            <h2>14. Changes to Terms</h2>
            <p>We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new Terms of Service on this page and updating the "Last updated" date. Continued use of the Service after changes constitutes acceptance of the new terms.</p>
          </section>

          <section>
            <h2>15. Severability</h2>
            <p>If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that the Terms will otherwise remain in full force and effect.</p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService; 